import { Paper, Typography } from "@mui/material";
import { Info } from "@/components/VulnerabilityWatch/Info.tsx";
import SplitBar from "@/components/VulnerabilityWatch/Portal/SplitBar.tsx";
import type { KnownPortalOverview } from "@/types";
import { buildAttemptSegments, buildStepSegments } from "@/utils/portalOverview.ts";
import * as copy from "@/utils/vulnerabilityCopy.ts";

export default function TrafficSection({ overview }: { readonly overview: KnownPortalOverview | null }) {
  return (
    <Paper variant="outlined" component="section" aria-label={copy.TRAFFIC} sx={{ p: 3 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{copy.TRAFFIC}<Info text={copy.TIP_TRAFFIC} /></Typography>
      <Typography variant="subtitle2" sx={{ mt: 2 }}>{copy.BY_STEP}</Typography>
      <SplitBar label={copy.BY_STEP} segments={buildStepSegments(overview)} />
      <Typography variant="subtitle2" sx={{ mt: 3 }}>{copy.BY_RESULT}</Typography>
      <SplitBar label={copy.BY_RESULT} segments={buildAttemptSegments(overview)} />
    </Paper>
  );
}
